'use strict';

import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { HelpBlock } from 'react-bootstrap';

const TextInput = createReactClass({
  propTypes: {
    /**
     * Specify the size of the input.
     */
    bsSize: PropTypes.oneOf(['large', 'lg', 'small', 'sm']),
  },

  render() {
    const {bsSize, className, hasAux, ...otherProps} = this.props;

    return (
        <input
          {...otherProps}
          className={cx('form-control', {
            'has-aux': hasAux,
            'input-lg': bsSize === 'large' || bsSize === 'lg',
            'input-sm': bsSize === 'small' || bsSize === 'sm',
          }, className)}
          ref={input => this._input = input}
          type="text"
        />
    );
  },

  getInstance() {
    return this._input;
  },
});

export default TextInput;



// WEBPACK FOOTER //
// ./src/refer/TextInput.react.js